
















































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType,
    pageDataType,
    projectPageDataType
} from '../types';
import axios from "axios";
import {
    pageData
} from "../store/pageData";
import {
    HOST
} from "../global";
import {
    FETCH_PROJECT_DATA
} from "../store/actions.names";
import {
    ADD_ANIMATION,
    SET_PROJECT_CURRENT_PAGE
} from "../store/mutations.names";
import {
    TimelineMax,
    Power1,
    Power2,
    Power4
} from "gsap";
import VueWow from "vue-wow";
import {
    UAnimateContainer,
    UAnimate
} from "vue-wow";
@Component({
    name: "relatedProject",
    components: {
        UAnimateContainer,
        UAnimate
        // ProjectComp
    }
})
export default class relatedProject extends Vue {
    @Getter("pageData") public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Prop() public compData!: string | null;
    @Getter("relatedProjects") public relatedProjectSearch!: any | null;
    @Getter("projectList") public pages!: projectPageDataType[];
    public HOST: string = HOST;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    @Action(FETCH_PROJECT_DATA)[FETCH_PROJECT_DATA]: any;
    @Mutation(SET_PROJECT_CURRENT_PAGE) public[SET_PROJECT_CURRENT_PAGE]: any;
    public addedAnimation: boolean = false;
    @Action(FETCH_PROJECT_DATA)[FETCH_PROJECT_DATA]: any;
    @Mutation(SET_PROJECT_CURRENT_PAGE) public[SET_PROJECT_CURRENT_PAGE]: any;
    public pageLoaded: boolean = false;
    public urlResolved = false;
    @Getter("projectList") public projectPageDataType!: projectPageDataType[];

//     public getHeight() {
//         var d: any = document;
//          setTimeout(() => {
//         var proj = d.querySelector('.project-thumb');
//   //  proj.style.backgroundColor = "red";
//         document.body.style.height = (d.body.clientHeight + proj.clientHeight)-(239) + 'px';
//         console.log(proj.clientHeight);
//           }, 8000);
       
//     }
    mounted() {
      //  this.getHeight();
        //  var footer = d.getElementsByTagName('footer');

    }

    // showCont: boolean = false;
    //public scroll: any | null = null;

    // get relatedProject(): projectPageDataType[] {
    //     return this.relatedProjectSearch({
    //         location: this.pageData.location,
    //         type: this.pageData.apartment_type
    //     });
    // }

    // get sortedFloorPlan(): any | null {
    //     if (!this.pageData) {
    //         return null;
    //     }
    //     let data: any = {};

    //     for (
    //         let index = 0; index < this.pageData.floor_plan_details.length; index++
    //     ) {
    //         const element = this.pageData.floor_plan_details[index];
    //         let d = element.value;
    //         d.id = element.id;
    //         d.type = element.type;
    //         data[d.floor_number] = d;
    //     }
    //     return data;
    // }

    // public getCompData(type: string, value: any) {
    //     if (type == "floor_plan") {
    //         value.plan = this.sortedFloorPlan;
    //     }
    //     return value;
    // }

    // public handleRouteChange(newVal: any, oldVal: any) {
    //     this.urlResolved = true;
    // }

    // public mounted() {
    //     let dc: any = this.pageData;
    //     if (dc) {
    //         this[FETCH_PROJECT_DATA](dc.meta.parent.id);
    //     }

    //     //  console.log(this.pageData.id);
    // }
    // pageDataChangeHandler(val: any | null, oldval: any | null) {
    //     if (val) {
    //         this[FETCH_PROJECT_DATA](val.meta.parent.id);
    //     }
    // }
    get relatedProject(): projectPageDataType[] {
        return this.relatedProjectSearch({
            location: this.pageData.location,
            type: this.pageData.apartment_type
        });
    }
    public relatedAnim(): void {
        var relatedAnim = new TimelineMax({});
        relatedAnim
            .staggerFrom(
                ".project-thumb",
                0.9, {
                    yPercent: 40,
                    opacity: 0,
                    ease: Power1.easeOut,
                    clearProps: "all"
                },
                0.1
            )
        // .staggerFrom(".design-items li", 0.8, {
        //     yPercent: 40,
        //     opacity: 0,
        //     ease: Power1.easeOut,
        //     clearProps: "all"
        // });
        if (this.last) {
            this.$emit("loaded");
        }
    }

}
